module.exports = __webpack_public_path__ + "resources/img/img_nginx_en.afbcc7a0889aba3c6418f573328ea7db.png";